import React from 'react';
import { FaClock } from 'react-icons/fa';
import { QueueStatus as QueueStatusType } from './types';
 
interface QueueStatusProps {
  status: QueueStatusType;
  onRetryFailed: () => void;
}
 
export const QueueStatus: React.FC<QueueStatusProps> = ({ status, onRetryFailed }) => {
  return (
    <>
      {status.pending > 0 && (
        <div
          style={{
            position: 'fixed',
            top: '72px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 50,
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '6px 16px',
            borderRadius: '999px',
            background: 'rgba(13,26,26,0.92)',
            border: '1.5px solid rgba(90,184,184,0.3)',
            color: '#7ecece',
            fontSize: '11px',
            fontWeight: 900,
            letterSpacing: '1px',
            backdropFilter: 'blur(8px)',
            boxShadow: '3px 3px 0 rgba(13,26,26,0.4)',
            whiteSpace: 'nowrap',
          }}
        >
          <FaClock style={{ fontSize: '10px', animation: 'pulse 1.5s ease-in-out infinite' }} />
          <span>SYNCING {status.pending} POST{status.pending > 1 ? 'S' : ''}...</span>
        </div>
      )}
 
      {status.failed > 0 && (
        <div
          style={{
            position: 'fixed',
            top: status.pending > 0 ? '108px' : '72px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 50,
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '6px 14px',
            borderRadius: '999px',
            background: 'rgba(13,26,26,0.92)',
            border: '1.5px solid rgba(224,80,80,0.35)',
            color: '#e05050',
            fontSize: '11px',
            fontWeight: 900,
            letterSpacing: '1px',
            backdropFilter: 'blur(8px)',
            boxShadow: '3px 3px 0 rgba(13,26,26,0.4)',
            whiteSpace: 'nowrap',
          }}
        >
          <span>{status.failed} POST{status.failed > 1 ? 'S' : ''} FAILED</span>
          <button
            onClick={onRetryFailed}
            style={{
              background: 'rgba(224,80,80,0.12)',
              border: '1.5px solid rgba(224,80,80,0.35)',
              color: '#e05050',
              borderRadius: '999px',
              padding: '3px 10px',
              fontSize: '10px',
              fontWeight: 900,
              cursor: 'pointer',
              letterSpacing: '1px',
            }}
          >
            RETRY
          </button>
        </div>
      )}
    </>
  );
};